import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ldu_1 = new (FormSize())(12.0, 1.0);
        this.mdu_1 = new (FormSize())(20.0, 5.0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FormSizeClass;
function FormSize() {
  if (FormSizeClass === VOID) {
    class $ {
      constructor(approximateWidth, approximateHeight, widthGrowWillingness, heightGrowWillingness) {
        Companion_getInstance();
        widthGrowWillingness = widthGrowWillingness === VOID ? 0.5 : widthGrowWillingness;
        heightGrowWillingness = heightGrowWillingness === VOID ? 0.5 : heightGrowWillingness;
        this.hds_1 = approximateWidth;
        this.ids_1 = approximateHeight;
        this.jds_1 = widthGrowWillingness;
        this.kds_1 = heightGrowWillingness;
        if (this.hds_1 < 0.0)
          throw Exception().ud('WAT');
      }
      td0(approximateWidth, approximateHeight, widthGrowWillingness, heightGrowWillingness) {
        return new (FormSize())(approximateWidth, approximateHeight, widthGrowWillingness, heightGrowWillingness);
      }
      lds(approximateWidth, approximateHeight, widthGrowWillingness, heightGrowWillingness, $super) {
        approximateWidth = approximateWidth === VOID ? this.hds_1 : approximateWidth;
        approximateHeight = approximateHeight === VOID ? this.ids_1 : approximateHeight;
        widthGrowWillingness = widthGrowWillingness === VOID ? this.jds_1 : widthGrowWillingness;
        heightGrowWillingness = heightGrowWillingness === VOID ? this.kds_1 : heightGrowWillingness;
        return $super === VOID ? this.td0(approximateWidth, approximateHeight, widthGrowWillingness, heightGrowWillingness) : $super.td0.call(this, approximateWidth, approximateHeight, widthGrowWillingness, heightGrowWillingness);
      }
      toString() {
        return 'FormSize(approximateWidth=' + this.hds_1 + ', approximateHeight=' + this.ids_1 + ', widthGrowWillingness=' + this.jds_1 + ', heightGrowWillingness=' + this.kds_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.hds_1);
        result = imul(result, 31) + getNumberHashCode(this.ids_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.jds_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.kds_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FormSize()))
          return false;
        if (!equals(this.hds_1, other.hds_1))
          return false;
        if (!equals(this.ids_1, other.ids_1))
          return false;
        if (!equals(this.jds_1, other.jds_1))
          return false;
        if (!equals(this.kds_1, other.kds_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FormSize');
    FormSizeClass = $;
  }
  return FormSizeClass;
}
var FormLayoutPreferences_Inline_instance;
var FormLayoutPreferences_Block_instance;
var FormLayoutPreferences_Field_instance;
var FormLayoutPreferences_Unbound_instance;
var FormLayoutPreferences_ScreenBound_instance;
var FormLayoutPreferences_entriesInitialized;
function FormLayoutPreferences_initEntries() {
  if (FormLayoutPreferences_entriesInitialized)
    return Unit_instance;
  FormLayoutPreferences_entriesInitialized = true;
  FormLayoutPreferences_Inline_instance = FormLayoutPreferences().cei('Inline', 0, 12.0, null);
  FormLayoutPreferences_Block_instance = FormLayoutPreferences().cei('Block', 1, 100.0, 12.0);
  FormLayoutPreferences_Field_instance = FormLayoutPreferences().cei('Field', 2, 12.0, 2.0);
  FormLayoutPreferences_Unbound_instance = FormLayoutPreferences().cei('Unbound', 3, null, null);
  FormLayoutPreferences_ScreenBound_instance = FormLayoutPreferences().cei('ScreenBound', 4, 100.0, null);
}
var FormLayoutPreferencesClass;
function FormLayoutPreferences() {
  if (FormLayoutPreferencesClass === VOID) {
    class $ extends Enum() {
      static cei(name, ordinal, approximateWidthBound, approximateHeightBound) {
        approximateWidthBound = approximateWidthBound === VOID ? null : approximateWidthBound;
        approximateHeightBound = approximateHeightBound === VOID ? null : approximateHeightBound;
        var $this = this.c4(name, ordinal);
        $this.sdy_1 = approximateWidthBound;
        $this.tdy_1 = approximateHeightBound;
        return $this;
      }
    }
    initMetadataForClass($, 'FormLayoutPreferences');
    FormLayoutPreferencesClass = $;
  }
  return FormLayoutPreferencesClass;
}
function FormLayoutPreferences_Block_getInstance() {
  FormLayoutPreferences_initEntries();
  return FormLayoutPreferences_Block_instance;
}
function FormLayoutPreferences_Field_getInstance() {
  FormLayoutPreferences_initEntries();
  return FormLayoutPreferences_Field_instance;
}
function FormLayoutPreferences_ScreenBound_getInstance() {
  FormLayoutPreferences_initEntries();
  return FormLayoutPreferences_ScreenBound_instance;
}
//region block: exports
export {
  FormSize as FormSize383y0pj5845uy,
  FormLayoutPreferences_Block_getInstance as FormLayoutPreferences_Block_getInstance2bsp7v6nfhpj1,
  FormLayoutPreferences_Field_getInstance as FormLayoutPreferences_Field_getInstanceniwfeoycub95,
  FormLayoutPreferences_ScreenBound_getInstance as FormLayoutPreferences_ScreenBound_getInstanceoel3z407rvau,
  Companion_getInstance as Companion_getInstance17fcxlkqs50ig,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
